'use strict';

let dismissedAlerts = sessionStorage.getItem('dismissedAlerts') ? sessionStorage.getItem('dismissedAlerts').split(',') : [];

const alertNodes = Array.from(document.querySelectorAll('[data-alert-item]')),

	deleteNode = event => {
		if (event.propertyName === 'opacity') {
			event.currentTarget.parentNode.removeChild(event.currentTarget);
		}
	},

	dismissAlert = event => {
		const alert = event.currentTarget.closest('.alert__item');

		dismissedAlerts.push(alert.dataset.alertItem);
		sessionStorage.setItem('dismissedAlerts', dismissedAlerts);
		dismissedAlerts = sessionStorage.getItem('dismissedAlerts').split(',');

		alert.classList.add('alert__item--hidden');

		alert.addEventListener('transitionend', deleteNode);
	};

if (alertNodes) {
	for (let alert of alertNodes.values()) {
		if (dismissedAlerts.includes(alert.dataset.alertItem)) {
			alert.parentNode.removeChild(alert);
		} else {
			alert.classList.remove('alert__item--hidden');
		}

		const closeButton = alert.querySelector('.alert__close-button-container button');

		if (closeButton) {
			closeButton.addEventListener('click', dismissAlert);
		}
	}
}
